import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

// combined campaigns
export const combinedCampaignsSelector = createSelector(
  ({ combinedData }) => combinedData.combinedCampaigns.data,
  data => data
)

export const combinedCampaignsIsLoadingSelector = createSelector(
  ({ combinedData }) => combinedData.combinedCampaigns.isLoading,
  isLoading => isLoading
)

export const combinedCampaignsErrorSelector = createSelector(
  ({ combinedData }) => combinedData.combinedCampaigns.error,
  error => error
)

export const combinedCampaignsWasLoadedSelector = createSelector(
  ({ combinedData }) => combinedData.combinedCampaigns.wasLoaded,
  wasLoaded => wasLoaded
)

export const lifetimeDatePresetCombinedCampaignSelector = campaignId =>
  createSelector(
    ({ combinedData }) => combinedData.combinedCampaigns.lifetimeDatePresetCombinedCampaigns,
    lifetimeDatePresetCombinedCampaigns =>
      lifetimeDatePresetCombinedCampaigns?.campaigns?.find(({ id }) => id === campaignId)
  )

// combined line items
export const combinedLineItemsSelector = createSelector(
  ({ combinedData }) => combinedData.combinedLineItems.results,
  results => results
)

export const combinedLineItemsIsLoadingSelector = createSelector(
  ({ combinedData }) => combinedData.combinedLineItems.isLoading,
  isLoading => isLoading
)

export const combinedLineItemsErrorSelector = createSelector(
  ({ combinedData }) => combinedData.combinedLineItems.error,
  error => error
)

export const combinedLineItemsWasLoadedSelector = createSelector(
  ({ combinedData }) => combinedData.combinedLineItems.wasLoaded,
  wasLoaded => wasLoaded
)

export const lifetimeDatePresetCombinedLineItemSelector = (campaignId, lineItemId) =>
  createSelector(
    ({ combinedData }) => combinedData.combinedLineItems.lifetimeDatePresetCombinedLineItems,
    lifetimeDatePresetCombinedLineItems => {
      const campaign = lifetimeDatePresetCombinedLineItems?.find(({ campaign_id }) => campaign_id === campaignId)
      const campaignLineItems = campaign?.line_items || []
      return campaignLineItems.find(({ id }) => id === lineItemId)
    }
  )

// combined graphs
export const combinedGraphsSelector = createSelector(
  ({ combinedData }) => combinedData.combinedGraphs.results,
  results => results
)

export const combinedGraphsIsLoadingSelector = createSelector(
  ({ combinedData }) => combinedData.combinedGraphs.isLoading,
  isLoading => isLoading
)

export const combinedGraphsErrorSelector = createSelector(
  ({ combinedData }) => combinedData.combinedGraphs.error,
  error => error
)

export const combinedGraphsWasLoadedSelector = createSelector(
  ({ combinedData }) => combinedData.combinedGraphs.wasLoaded,
  wasLoaded => wasLoaded
)

// combined segmented data
export const combinedSegmentedDataSelector = createSelector(
  ({ combinedData }) => combinedData.combinedSegmentedData.data,
  data => data
)

export const combinedSegmentedDataIsLoadingSelector = createSelector(
  ({ combinedData }) => combinedData.combinedSegmentedData.isLoading,
  isLoading => isLoading
)

export const combinedSegmentedDataWasLoadedSelector = createSelector(
  ({ combinedData }) => combinedData.combinedSegmentedData.wasLoaded,
  wasLoaded => wasLoaded
)

export const combinedSegmentedDataErrorSelector = createSelector(
  ({ combinedData }) => combinedData.combinedSegmentedData.error,
  error => error
)

// combined ads
export const combinedAdsSelector = createSelector(
  ({ combinedData }) => combinedData.combinedAds.results,
  results => results
)

export const combinedAdsIsLoadingSelector = createSelector(
  ({ combinedData }) => combinedData.combinedAds.isLoading,
  isLoading => isLoading
)

export const combinedAdsWasLoadedSelector = createSelector(
  ({ combinedData }) => combinedData.combinedAds.wasLoaded,
  wasLoaded => wasLoaded
)

export const combinedAdsErrorSelector = createSelector(
  ({ combinedData }) => combinedData.combinedAds.error,
  error => error
)

// date range
export const combinedDataDateRangeSelector = createSelector(
  ({ combinedData }) => combinedData.dateRange,
  dateRange => dateRange
)

// Export combined campaigns data as csv
export const exportCombinedCampaignsDataAsCsvSelector = createSelector(
  ({ combinedData }) => combinedData.exportCombinedCampaignsDataAsCsv.data,
  data => data
)

export const exportCombinedCampaignsDataAsCsvIsLoadingSelector = createSelector(
  ({ combinedData }) => combinedData.exportCombinedCampaignsDataAsCsv.isLoading,
  isLoading => isLoading
)

export const exportCombinedCampaignsDataAsCsvErrorSelector = createSelector(
  ({ combinedData }) => combinedData.exportCombinedCampaignsDataAsCsv.error,
  error => error
)

export const exportCombinedCampaignsDataAsCsvWasLoadedSelector = createSelector(
  ({ combinedData }) => combinedData.exportCombinedCampaignsDataAsCsv.wasLoaded,
  wasLoaded => wasLoaded
)
